
import "./Loading.css";

function Loading(){
return(
    <>
    <div className="loading-cont">
        <div className="line-container">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
        </div>
    </div>
    
    </>
)
}
export default Loading;